export default __webpack_public_path__ + "static/article-finance-perfect-personal-loan-5bcce3d0e4c66292d58af14d2f6e42bc.jpg";